import styles from './statistic-modal.module.scss'

export default function SendStatisticStepFour({ isSkip = false }) {
  return (
    <div className={styles['statisticStepFour']}>
      <b>Thank You for Your Response!</b>
      <p>Wishing you smooth sailing in your new role! ⚓</p>
    </div>
  )
}
